import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LearnProgressChart } from 'src/components/ui/GlobalComponents/LearnProgressChart/LearnProgressChart';
import { useChallenge } from 'src/hook/data/useChallenge';
import useUser from 'src/hook/data/useUser';
import { IconLocation } from 'src/utils/URLUtils';
import styles from './ChallengeHeader.module.scss';
import { WordListsModal } from './WordListsModal/WordListsModal';

export const ChallengeHeader = () => {
    const { t } = useTranslation();
    const [isWordListsModalOpen, setIsWordListsModalOpen] = useState(false);
    const { userInfo, isProUser } = useUser();
    const navigate = useNavigate();
    const { setAutoPlay } = useChallenge();

    const handleHeartClick = () => {
        navigate('/earn-heart');
    };

    const handleClose = () => {
        setAutoPlay(true);
        navigate('/');
    };

    return (
        <>
            <section className={styles.challengeHeader}>
                <div className={styles.headerLeft}>
                    <img className='XsIcon' src={IconLocation('x')}
                        alt={t('back')} onClick={handleClose} />
                    {!isProUser() && (
                        <div className={styles.heartContainer}>
                            <img src={IconLocation(userInfo?.Hearts === 0 ? 'no-heart' : 'heart')}
                                alt={t('heart')} onClick={handleHeartClick} />
                            <span className={styles.heartCount}>
                                {userInfo?.Hearts}</span>
                        </div>
                    )}
                </div>
                <div className={styles.filterContainer}>
                    <LearnProgressChart />
                    <img className='icon' src={IconLocation('filter')} alt={t('back')} onClick={() => setIsWordListsModalOpen(true)} />
                </div>
            </section >
            {isWordListsModalOpen &&
                <WordListsModal
                    isOpen={isWordListsModalOpen}
                    onClose={() => setIsWordListsModalOpen(false)}
                />
            }
        </>
    );
};
